import { render, staticRenderFns } from "./RecordingExtra.vue?vue&type=template&id=4ed14071&scoped=true&"
import script from "./RecordingExtra.vue?vue&type=script&lang=js&"
export * from "./RecordingExtra.vue?vue&type=script&lang=js&"
import style0 from "./RecordingExtra.vue?vue&type=style&index=0&id=4ed14071&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed14071",
  null
  
)

export default component.exports